export default __webpack_public_path__ + "static/media/section-process-bg3.983c82f9.png";